export default {
  common: {
    done: 'Fatto',
    term: 'Termine',
    year: 'Anno | Anni',
    years: 'Anni',
    yr: '/yr',
    month: 'Mese | Mesi',
    quantity: 'Quantità',
    add: 'Aggiungi',
    loading: 'Caricamento',
    error: "Correggi gli errori o <a  class='link-info'>remove</a> rimuovi l'articolo dal carrello.",
    domain: 'Dominio',
    edit: 'Modifica',
    account: 'Account',
    accounts: 'Account',
    zone: 'Zona',
    zones: 'Zone',
    relay: 'Relay',
    relay: 'Relay',
    enter_domain: 'Inserisci un dominio',
    hostnames: 'I Hostname',
    term_callout: 'Hai bisogno di una durata più lunga?',
    select_term: 'Seleziona il tuo termine',
    recommended: 'Consigliato',
    save: 'Salva',
    includes: 'Include',
    adjusting_preview: "Regolazione dell'anteprima",
    coupon_code_is_not_valid: 'Il codice coupon non è valido.',
    contact_support_if_you_believe_this_is_an_error: "Contatta l'assistenza se ritieni che si tratti di un errore.",
    coupon_applied: 'Tagliando applicato',
    sub_total: 'Totale parziale',
    available_credit: 'Credito disponibile',
    credit_used: 'Credito utilizzato',
    coupon_code_will_be_applied_once_logged_in: "Il codice coupon verrà applicato una volta effettuato l'accesso.",
    monthly: 'Mensile',
    annually: 'Annualmente'
  },
  topnav: {
    planbuilder: 'Creatore di piani',
    payment: 'Pagamento',
    orderconfirmation: "Conferma d'ordine"
  },
  plan_builder: {
    undo: 'Annulla',
    item_removed: 'Un servizio è stato rimosso dal tuo carrello.',
    select_term: '<span class="text-semibold">Seleziona un termine</span> per il tuo abbonamento',
    years: 'anni',
    apply: 'Applica',
    total: 'Totale',
    proceed_to_checkout: 'Procedi al pagamento',
    removed_items: 'I seguenti servizi sono stati rimossi dal carrello perché hai già un abbonamento attivo per questi prodotti:',
    billing_management: 'Visita la pagina <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Gestione della fatturazione</a> se vuoi rinnovarli.',
    open_invoice: 'Hai già una fattura aperta per i servizi nel carrello che sono stati rimossi.',
    invoice_link: 'Consulta pagina <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Gestione della fatturazione</a> e paga queste fatture per ripristinare i tuoi servizi.',
    empty_cart: 'Il tuo carrello è vuoto',
    purchase_services: 'Scopri tutti i servizi che puoi acquistare su <a href="/" class="text-info text-decoration-none">No-IP</a>',
    updated_enhanced_item: 'Al momento hai <span class="text-semibold">{hostcount} hostnames</span> e questo supera <span class="text-semibold">{itemtitle} {itemoptionsquantity} Hostname(s)</span>. Abbiamo aggiornato il tuo carrello per passare al prossimo abbonamento disponibile, <span class="text-semibold">{newitemtitle} {newitemoptionsquantity} Hostnames</span>.'
  },
  account: {
    create_an_account: 'Crea un account',
    have_an_account: 'Hai un account',
    create_account: 'Crea account',
    log_in: 'Accedi',
    email: 'E-mail',
    user_password: 'Password',
    tos: "Accetto i <a href='/legal/tos'>Termini di servizio</a> e l'<a href='/legal/privacy'>Informativa sulla privacy</a>.",
    newsletter: 'Inviami newsletter e offerte speciali',
    log_in: 'Accedi',
    email_username: 'Indirizzo e-mail o nome utente',
    forgotpassword: 'Hai dimenticato la password?',
    login_continue: 'Accedi e continua',
    auth_failure: 'La combinazione nome utente/password non è corretta. Riprova.',
    too_many_attempts: 'Il tuo indirizzo IP ha inoltrato questo modulo troppe volte di recente. Prima di riprovare, attendi qualche minuto.',
    too_many_attempts: "Il tuo account è stato bloccato a causa degli eccessivi tentativi di inserire la password non andati a buon fine. L'account verrà sbloccato tra 15 minuti e, a quel punto, potrai provare nuovamente ad accedere. Inoltre, puoi chiamare il numero 1-877-367-6647 durante gli orari d'ufficio, dal lunedì al venerdì dalle 6:30 alle 17:30 (Ora del Pacifico), per farti sbloccare immediatamente l'account. Si tratta di una funzione di sicurezza per evitare tentativi di accesso forzato. Se hai dimenticato la password, usa il nostro modulo di password dimenticata, in modo da farti inviare un link di ripristino della password. Successivamente, riprova ad accedere dopo 15 minuti.",
    captcha_failure: "reCAPTCHA non andato a buon fine. Prima di effettuare l'accesso, dovrai completare correttamente il reCAPTCHA.",
    newsletter: 'Inviami newsletter e offerte speciali',
    create_account: 'Crea un account',
    logged_in_as: 'Collegato come',
    create_an_account: 'Hai bisogno di creare un account?',
    already_have_an_account: 'Hai già un account?',
    sign_up_with_google: 'Registrati con Google',
    sign_in_with_google: 'Accedi con Google',
    sign_up_with_microsoft: 'Registrati con Microsoft',
    sign_in_with_microsoft: 'Accedi con Microsoft'
  },
  domain_input: {
    tooltip: 'Inserisci un dominio di tua proprietà da utilizzare con questo servizio. Nota: questa azione non registrerà il dominio.'
  },
  domain_reg: {
    tooltip: 'Registra il tuo dominio con No-IP un registrar accreditato ICANN.'
  },
  account_enhanced: {
    tooltip: 'Accedi in remoto a un computer, dispositivo o rete senza preoccuparti delle conferme mensili del hostname.',
    hostnames: 'Hostname'
  },
  support_priority: {
    tooltip: 'Un canale di supporto di risposta prioritaria gestito dal nostro gentile ed esperto team di supporto tecnico. Il tuo ticket, o la tua chiamata di supporto, viene messa in prima linea, in modo da ricevere aiuto quando ne hai più bisogno.'
  },
  dns_tier: {
    tooltip: 'DNS veloce e affidabile per il tuo dominio, supportato dalla nostra solida rete Anycast, con oltre 100 punti di presenza situati in tutto il mondo.'
  },
  dns_squared: {
    tooltip: "Massimizza i tempi di attività e aumenta l'affidabilità utilizzando la tua infrastruttura DNS esistente."
  },
  mail_backupmx: {
    tooltip: 'Backup MX ti dà la tranquillità. Se il tuo server di posta non funziona, non perderai le e-mail importanti.'
  },
  mail_reflector: {
    tooltip: 'Esegui il tuo server di posta anche se il tuo ISP blocca la porta 25'
  },
  mail_pop: {
    tooltip: "POP3/IMAP è l'opzione ideale per coloro che non vogliono il disturbo di gestire il proprio server di posta."
  },
  mail_forwarding: {
    tooltip: "L'inoltro della posta ti consente di ricevere e-mail per il tuo dominio e di inoltrarle a un account esistente."
  },
  mail_smtp: {
    tooltip: 'SMTP è per gli amministratori che hanno una porta 25 bloccata o per i road warrior che non vogliono modificare le impostazioni SMTP.'
  },
  ssl_rapid: {
    tooltip: 'Protegge un singolo dominio con crittografia avanzata. Viene rilasciato in pochi minuti, aiutandoti a sviluppare e lanciare rapidamente un sito sicuro.'
  },
  ssl_rapid_dv: {
    tooltip: 'Protegge un singolo dominio con crittografia avanzata. Viene rilasciato in pochi minuti, aiutandoti a sviluppare e lanciare rapidamente un sito sicuro.'
  },
  ssl_premium: {
    tooltip: "Fornisce procedure di autenticazione complete (hostname e verifica dell'identità) con un'elevata garanzia che rende questo certificato perfetto per proteggere il tuo dominio professionale."
  },
  ssl_rapid_wildcard: {
    tooltip: 'Proteggi sottodomini illimitati con una crittografia avanzata. I certificati vengono emessi in pochi minuti e sono il modo più conveniente per proteggere più domini.'
  },
  ssl_rapid_wildcard_dv: {
    tooltip: 'Proteggi sottodomini illimitati con una crittografia avanzata. I certificati vengono emessi in pochi minuti e sono il modo più conveniente per proteggere più domini.'
  },
  ssl_trustcor_standard: {
    tooltip: 'Protegge un singolo hostname con crittografia avanzata. Viene rilasciato in pochi minuti, aiutandoti a sviluppare e lanciare rapidamente un sito sicuro.'
  },
  ssl_trustcor_premium: {
    tooltip: 'Protegge un singolo hostname con crittografia avanzata. Viene rilasciato in pochi minuti, aiutandoti a sviluppare e lanciare rapidamente un sito sicuro.'
  },
  ssl_trustcor_wildcard: {
    tooltip: 'Proteggi sottodomini illimitati con una crittografia avanzata. I certificati vengono emessi in pochi minuti e sono il modo più conveniente per proteggere più domini.'
  },
  monitor_basic: {
    tooltip: "Avere un server inattivo è un problema, non saperlo è anche peggio. Ricevi immediatamente un avviso quando c'è un problema."
  },
  monitor_advanced: {
    tooltip: 'Monitoraggio del server 24 ore su 24, 7 giorni su 7, incluso il failover automatico. Fai in modo che le tue impostazioni DNS puntino automaticamente al tuo server di backup o alla pagina personalizzata al volo.'
  },
  team_login: {
    tooltip: 'Team Login ti consente di coordinarti senza problemi con diversi accessi affiliati al tuo account.'
  },
  registration_domain: {
    tooltip: 'Registra il tuo dominio con No-IP un registrar accreditato ICANN.',
    bundle_discount: 'Sconto per pacchetto',
    you_saved: 'Hai salvato',
    hide_info: 'Sì, nascondi le mie informazioni personali dal mondo per',
    no_thanks: 'No, grazie',
    private_registration_no: 'Registrazione privata - No'
  },
  registration_transfer: {
    tooltip: 'Trasferisci il tuo dominio da un altro registrar a No-IP.'
  },
  registration_privacy: {
    tooltip: 'La registrazione privata mantiene private le informazioni di contatto del tuo dominio. Impostiamo un proxy che gestisce lo spam e ti inoltra ciò di cui hai bisogno.',
    private_registration: 'Private Registration'
  },
  host_redemption: {
    tooltip: 'Recupera il tuo hostname da Redemption e mantieni la stessa configurazione che avevi prima di Redemption.'
  },
  dns_pro: {
    tooltip: 'Crea nomi host sul tuo dominio o utilizza un dominio di proprietà senza IP con DNS dinamico di livello professionale che si adatta alle tue esigenze.'
  },
  domain_contact: {
    contact: {
      oganization: 'Organizzazione',
      email_address: 'Indirizzo e-mail',
      first_name: 'Nome',
      last_name: 'Cognome',
      address: 'Indirizzo',
      address2: 'Indirizzo 2',
      country: 'Paese',
      state_province: 'Regione / Provincia',
      city: 'Città',
      postal_zip: 'CAP',
      phone_number: 'Telefono'
    },
    contact_form: {
      domain_contact: 'Contatto di dominio',
      domain_contact_text: 'La registrazione del dominio richiede informazioni di contatto del dominio valide. Questo significa che il tuo nome e i tuoi dati di contatto saranno pubblicamente disponibili nel registro WHOIS. Se hai aggiunto la Registrazione Privata, il record mostrerà le nostre informazioni invece delle tue. Non preoccuparti di perdere qualcosa, ti inoltreremo le informazioni importanti.',
      add_private_reg: 'Aggiungi subito Registrazione Privata',
      existing_domain_contact: 'Usa un contatto di dominio esistente ',
      new_domain_conact: 'Crea un nuovo contatto di dominio',
      verifying: 'Verifica in corso',
      continue: 'Continua',
      an_unexpected_error: "Siamo spiacenti, abbiamo riscontrato un errore imprevisto, riprova tra qualche minuto. Se questo errore continua a verificarsi, per favore segnalalo in un <a href='/ticket'>ticket di supporto</a> unitamente ai tuoi dati di contatto."
    },
    order_summary: {
      order_summary: 'Riepilogo ordine',
      edit: 'Modifica'
    }
  },
  upsell: {
    add_to_cart: 'Aggiungi al carrello',
    plus_description: 'DNS dinamico completamente personalizzato creando un nome host facile da ricordare sul tuo dominio.',
    enhanced_description: 'Crea un nome host facile da ricordare per accedere al tuo dispositivo da remoto e non preoccuparti mai di confermare il tuo nome host finché il tuo abbonamento rimane attivo.',
    priority_description: 'Il supporto prioritario No-IP è un canale di supporto con risposta prioritaria gestito dal nostro team di supporto tecnico amichevole ed esperto. Il supporto prioritario ti consente di ottenere il supporto di cui hai bisogno il più rapidamente possibile.',
    rapid_description: 'I certificati RapidSSL Basic DV proteggono un singolo dominio con una crittografia avanzata. Viene emesso in pochi minuti, aiutandoti a sviluppare e lanciare rapidamente un sito web sicuro. È un modo rapido ed economico per proteggere il tuo sito web.',
    rapid_wildcard_description: 'I certificati RapidSSL Wildcard proteggono sottodomini illimitati con crittografia avanzata. I certificati vengono emessi in pochi minuti e rappresentano il modo più conveniente per proteggere più domini.',
    team_login_description: 'Team Login ti consente di invitare altri membri del team al tuo account. Consenti ai membri del tuo team di aiutarti a fare di più con la gestione di clienti, abbonamenti e altro.',
    recommended: 'Consigliato',
    team_login_tooltip: 'Ogni account No-IP è associato a un proprietario. Hai bisogno di un altro accesso? Aggiungi un membro del team al tuo account.',
    per_team_member: 'per membro del team'
  }
};
